export const Videos = {
    Persona_Creation: "/videos/Skills_Architect_Persona_Creation.mp4",
    Assign_Skills_Persona: "/videos/Skills_Architect_Persona_Part2.mp4"
};
